export default __webpack_public_path__ + "static/media/flag-congo(republic).17124798.svg";